import Button from "antd/lib/button";
import React, { useContext } from "react";
import { NavigationContext } from "../../context/NavigationContext";
import { ToastContext } from "../../context/ToastContext";

type Props = {};

function AdminLoginButton({}: Props) {
  const { login } = useContext(NavigationContext);
  const { loadMessage } = useContext(ToastContext);

  const handleLogin = () => {
    loadMessage("Logging in as Admin", () =>
      login("johan.martensson@mithings.se", "bike")
        .then((user) => {
          return "Successfully logged in";
        })
        .catch((res) => {
          throw Error("Wrong username and/or password");
        })
    );
  };

  return <Button onClick={handleLogin}>Login as Admin</Button>;
}

export default AdminLoginButton;
